<template>
  <div class="form-group centix-vue-selectinput row" :class="{ 'disabled' : !isEnabled }" v-show="isVisible">
      <label :class="labelCssClass" class="col-form-label">{{ label }}</label>
      <span class="holder-span" :class="inputCssClass">
        <time-input v-model="localvalue" @value-changed="valueChanged" :is-enabled="isEnabled" :disabled="!isEnabled" :required="required" class="input-item"/>
      </span>
      <div class="model-state-error col-12">
        {{ validationError }}
      </div>
  </div>
</template>
<script>
import timeinput from 'components/Input/TimeInput.vue';
import FormMixin from './formitem.js';

export default {
  mixins: [FormMixin],
  components: {
    'time-input': timeinput
  },
  props: {
    value: {
      required: true
    }
  },
  data () {
    return {
      formType: 'time',
      localvalue: null
    };
  },
  mounted () {
    this.localvalue = this.value;
  },
  methods: {
    raiseValueChanged (val) {
      this.$emit('change', val);
      this.emitFormChange();
    },
    valueChanged (val) {
      this.$log('value changed from inner component', val);
      if (val !== this.value) {
        this.raiseValueChanged(val);
      }
    },
    clearForm() {
      this.raiseValueChanged('');
    }
  },
  computed: {
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    value (newvalue, oldvalue) {
      this.localvalue = newvalue;
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'styles/settings.scss';

.centix-vue-boolinput {
  span.holder-span {
    position: relative;
    display: block;
  }
  &:not(.disabled) {
    .input-item {
      &.required {
        border: 1px solid $error;
      }
      &.filled {
        padding-right: 25px;
        border: 2px solid #80bdff;
      }
    }
  }
  .model-state-error {
    color: $error;
  }
}
</style>
